import { Component } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { BaseDirectiveObject } from '../../../app/components/common/base-directive-object';
import { FieldConfig } from '../../../app/api/contract-notice-dto';


@Component({
  templateUrl: 'pin.template.html',
  selector: 'signature-pin',
  providers: [DialogService]
})
export class SignaturePinComponent extends BaseDirectiveObject {

  public pin: string;

  constructor(private dialogRef: DynamicDialogRef) {
    super();
  }

  public getPINConfig(): FieldConfig {
    const fieldConfig = new FieldConfig();
    fieldConfig.jsonField = 'pin';
    fieldConfig.type = 'TEXT';
    fieldConfig.styleClass = 'w-100';
    fieldConfig.typePassword = true;
    fieldConfig.required = 'true';
    fieldConfig.descriptionKey = 'General.PIN';
    return fieldConfig;
  }

  public onSubmit(): void {
    this.dialogRef.close(this.pin);
  }

}
